module.exports = __webpack_public_path__ + "res/15-img_bg_l.46c4d0b46e5e3cd459ebb047801ca128.png";